

















































































































import {Component, Vue} from 'vue-property-decorator'
import {$} from '@/facade'
import {NeoHelper} from '@/helpers/NeoHelper'
import {OrbitHelper} from '@/helpers/OrbitHelper'
import {NetworkNamespace} from '@/enums/NetworkNamespace'
import {OrbitRefundTransactionStep} from '@/enums/OrbitRefundTransactionStep'
import {getN3InvocationBuilder} from '@/model/wallets/invocationsBuilder'
import OrbitRefundConfirmStep from '@/components/orbit/OrbitRefundConfirmStep.vue'
import OrbitLoadingTransactionStep from '@/components/orbit/OrbitLoadingTransactionStep.vue'
import OrbitInsufficientGasStep from '@/components/orbit/OrbitInsufficientGasStep.vue'
import OrbitUnexpectedErrorStep from '@/components/orbit/OrbitUnexpectedErrorStep.vue'
import OrbitRejectedByTheUserStep from '@/components/orbit/OrbitRejectedByTheUserStep.vue'
import OrbitSuccessStep from '@/components/orbit/OrbitSuccessStep.vue'
import {OrbitProject} from '@/model/resource/OrbitProject'
import {currentN3Network} from '@/helpers/NetworkModeRegistry'

@Component({
  computed: {
    OrbitRefundTransactionStep() {
      return OrbitRefundTransactionStep
    },
  },
  components: {
    OrbitRefundConfirmStep,
    OrbitLoadingTransactionStep,
    OrbitInsufficientGasStep,
    OrbitUnexpectedErrorStep,
    OrbitRejectedByTheUserStep,
    OrbitSuccessStep,
  },
})
export default class OrbitRefundContractModal extends Vue {
  currentStep: OrbitRefundTransactionStep = OrbitRefundTransactionStep.CONFIRM
  transactionHash: string | null = null

  handleCancel() {
    this.closeModal()
  }

  async handleConfirm() {
    if (!$.walletAdapter.n3Address) {
      $.modal.open('connectWalletModal', {
        networkNamespace: NetworkNamespace.n3,
      })
      $.toast.error(
        this.$translate(
          'components.OrbitRefundContractModal.ownerOnly'
        ) as string
      )
      return
    }
    const owners = await OrbitHelper.getOwners()
    if (!owners.find(o => o === $.walletAdapter.n3Address)) {
      $.toast.error(
        this.$translate(
          'components.OrbitRefundContractModal.ownerOnly'
        ) as string
      )
      return
    }
    await this.executeRefund()
  }

  async executeRefund() {
    try {
      const address = $.walletAdapter.n3Address!
      this.currentStep = OrbitRefundTransactionStep.WAITING_SIGNATURE

      const n3InvocationBuilder = getN3InvocationBuilder()
      const inv = n3InvocationBuilder.refundOrbitContractInvocation({
        recipientAddress: address,
      })

      this.transactionHash = await $.walletAdapter.invokeN3Wallet(inv)
      if (!this.transactionHash) {
        throw new Error('Undefined transaction')
      }

      this.currentStep = OrbitRefundTransactionStep.VALIDATING_TRANSACTION

      const isTransactionValid = await NeoHelper.validateTransaction(
        this.transactionHash
      )
      if (!isTransactionValid) {
        throw new Error('Failed to verify transaction')
      }

      await OrbitProject.markAllActiveUnfundedAfterContractRefund(
        currentN3Network()
      )

      this.currentStep = OrbitRefundTransactionStep.DONE
      $.toast.success('system.success.persist')
    } catch (error) {
      this.threatError(error)
    }
  }

  onClickCloseModal() {
    if (
      this.currentStep === OrbitRefundTransactionStep.WAITING_SIGNATURE ||
      this.currentStep === OrbitRefundTransactionStep.VALIDATING_TRANSACTION
    ) {
      return
    }

    this.closeModal()
  }

  closeModal() {
    this.currentStep = OrbitRefundTransactionStep.CONFIRM
    this.transactionHash = null
    this.$emit('close')
  }

  private threatError(error: any) {
    console.error(error)

    const isNeonWalletRejected =
      error.message && String(error.message).includes('rejected by the user')

    const isNeoLineWalletRejected =
      error.description &&
      error.description === 'The user cancels, or refuses the dapps request'

    if (isNeonWalletRejected || isNeoLineWalletRejected) {
      this.currentStep = OrbitRefundTransactionStep.REJECTED_BY_THE_USER
      return
    }

    const hasInsufficientFunds =
      error.message && String(error.message).includes('insufficient funds')
    if (hasInsufficientFunds) {
      this.currentStep = OrbitRefundTransactionStep.INSUFFICIENT_GAS
      return
    }

    this.currentStep = OrbitRefundTransactionStep.UNKNOWN_ERROR
  }
}
